export default "__VITE_ASSET__gN3g7w_Z__"